import { render, staticRenderFns } from "./Apcheck.vue?vue&type=template&id=221622e2"
import script from "./Apcheck.vue?vue&type=script&lang=js"
export * from "./Apcheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports